export default __webpack_public_path__ + "static/media/mobileBG.cb59b44b.png";